import styled from '@emotion/styled';
import { Box, IconButton, Stack, Tab, Tabs } from '@mui/material';

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  marginBottom: '41px',
  borderBottom: '1px solid rgba(0, 0, 0, 0.3)',
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  fontSize: '20px',
  color: theme.palette.blue.dark,

  '&.Mui-selected': {
    color: theme.palette.blue.text,
    // color: theme.palette.blue.dark,
  },
}));

export const StyledTrainedEnployeeWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  columnGap: '8px',
  fontWeight: '700',
}));

export const StyledAddEmployeePopup = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  padding: '77px 32px 37px',
  width: '680px',
  maxWidth: '95vw',
  maxHeight: '90vh',
  overflowY: 'auto',
  boxShadow: '0px 0px 58px 0px rgba(70, 125, 148, 0.14)',
  borderRadius: '20px',
}));

export const StyledPopupCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '37px',
  left: '23px',
  padding: 'unset',
}));

export const StyledCreateTrainingPopup = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  position: 'absolute',
  left: '0',
  height: '100%',
  padding: '40px 20px 40px 30px',
  borderRadius: '0 20px 20px 0',
  width: '817px',
  overflowY: 'auto',
}));

export const StyledValidationTabs = styled(Tabs)(({ theme }) => ({
  boxShadow: '0px 0px 58px 0px rgba(70, 125, 148, 0.14)',
  borderRadius: '24px',
  border: `1px solid ${theme.palette.blue.main}`,

  button: {
    color: theme.palette.blue.dark,
    opacity: 1,
    fontSize: '16px',

    '&.Mui-selected': {
      backgroundImage:
        'linear-gradient(90deg, #014D6C 0%, #014D6C 6.25%, #014E6D 12.5%, #01506E 18.75%, #015270 25%, #025573 31.25%, #025975 37.5%, #025D79 43.75%, #03627D 50%, #036781 56.25%, #046D86 62.5%, #04748C 68.75%, #057C92 75%, #068498 81.25%, #068D9F 87.5%, #0796A7 93.75%, #08A0AF 100%)',
      backgroundColor: 'transparent',
      color: theme.palette.white.main,
      borderRadius: '24px',
    },
  },

  '.MuiTabs-indicator': {
    display: 'none',
  },
}));

export const StyledSelectedEmployee = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.blue.light,
  border: `1px solid ${theme.palette.blue.main}`,
  borderRadius: '8px',
  padding: '12px 16px',
  marginBottom: '32px',
}));

export const StyledWorkArrangementEmplyeePopup = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  width: '817px',
  backgroundColor: 'rgba(0, 28, 39, 0.7)',
  zIndex: 1,
}));

export const StyledEmployeeConditions = styled(Stack)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '524px',
  borderRadius: '20px',
  backgroundColor: theme.palette.white.main,
}));
